export const EventTrackerNavigationReasons = {
    MibiStructPageBackButton: 'mibi-struct-page-back-button',

    SingleOrderPageBackButton: 'single-order-page-back-button',
    SingleOrderPageReportButton: 'single-order-page-report-button',

    SingleReportPageBackButton: 'single-report-page-back-button',
    SingleReportPageOrderButton: 'single-report-page-order-button',
    SingleReportPageCreateOrderButton: 'single-report-page-create-order-button',

    ReportsListReportSelected: 'reports-list-report-selected',

    OrdersListOrderSelected: 'orders-list-order-selected',

    PatientListCreateNewPatientButton: 'patient-list-create-new-patient-button',
    PatientListSelectPatientButton: 'patient-list-select-patient-button',
    PatientListImportPatient: 'patient-list-import-patient',

    NotFoundPageTimer: 'not-found-page-timer',
    NotFoundPageButton: 'not-found-page-button',

    ErrorPageButton: 'error-page-button',

    NavigationSidebarItem: 'nav-sidebar-item',

    StartPageCardClick: 'start-page-card-click',
    StartPageImageClick: 'start-page-image-click',
} as const;

export const EVENT_TRACKER_NAVIGATION_REASONS = Object.values(EventTrackerNavigationReasons);
